import "./style.css"

export const Box = ({ children, className="", style, ...props }) => {
    return (
        <div className={"box p-3 " + className} style={style} {...props}>{children}</div>
    )
}